import { BuilderConfig } from '../../../types/Builder';
import B2BOnlinePayment, { B2BOnlinePaymentProps } from './b2b-online-payment';

export const B2BOnlinePaymentBuilderConfig = {
    name: 'B2B Online Payment',
    inputs: [
        {
            name: 'title',
            type: 'string',
            defaultValue: '',
        },
        {
            name: 'description',
            type: 'string',
        },
        {
            name: 'backgroundColor',
            type: 'color',
            defaultValue: '#E7EAED',
        },
        {
            name: 'steps',
            type: 'list',
            subFields: [
                {
                    name: 'name',
                    type: 'string',
                    required: true,
                },
                {
                    name: 'description',
                    type: 'richText',
                },
                {
                    name: 'icon',
                    type: 'file',
                    required: true,
                },
                {
                    name: 'screenImage',
                    type: 'file',
                    required: true,
                },
                {
                    name: 'illustration',
                    type: 'file',
                    required: true,
                },
                {
                    name: 'illustrationRatio',
                    type: 'text',
                },
            ],
        },
    ],
};

const builderConfig: BuilderConfig<B2BOnlinePaymentProps> = {
    component: B2BOnlinePayment,
    config: B2BOnlinePaymentBuilderConfig,
};

export default builderConfig;
